import wrapperHOC from "@Utils/wrapperHOC";
import BudgetFriendlyProperties from ".";

interface BudgetFriendlySectionProps {
  gtagEventCategory: string;
  isDesktop?: boolean;
}

const BudgetFriendlySection = ({
  gtagEventCategory,
  isDesktop = false,
}: BudgetFriendlySectionProps) => (
  <BudgetFriendlyProperties gtagEventCategory={gtagEventCategory} isDesktop={isDesktop} />
);

export default wrapperHOC(BudgetFriendlySection, {
  componentName: "BudgetFriendlySection-SearchPage",
  showForChina: true,
  showForWhiteLable: true,
});
